module.exports = __webpack_public_path__ + "media/images/webpage/clips/spot-parts-c6f62d9b425fb40d3ec100d3bb3eacd8.webp";